import { render } from "./ProductCarouselPage.vue?vue&type=template&id=4179e82e&scoped=true"
import script from "./ProductCarouselPage.vue?vue&type=script&lang=js"
export * from "./ProductCarouselPage.vue?vue&type=script&lang=js"

import "./ProductCarouselPage.vue?vue&type=style&index=0&id=4179e82e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4179e82e"]])

export default __exports__